import { render } from "./SystemAdmin9.vue?vue&type=template&id=89562e8e&scoped=true"
import script from "./SystemAdmin9.vue?vue&type=script&lang=js"
export * from "./SystemAdmin9.vue?vue&type=script&lang=js"

import "./SystemAdmin9.vue?vue&type=style&index=0&id=89562e8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89562e8e"]])

export default __exports__